export const SELECT_TIMESLOT = 'selected timeslot'
export const STORE_SELECTED_SHOWROOM = 'storing selected showroom'
export const TOGGLE_EVENT_DATE_PICKER = 'toggles scheduler event date picker'
export const UPDATE_SELECTED_DATE = 'updating selected showroom date'

export function storeSelectedTimeSlot(selectedTimeSlot) {
  return {
    type: SELECT_TIMESLOT,
    selectedTimeSlot: {...selectedTimeSlot},
  }
}

export function storeSelectedShowroom(showroom) {
  return {
    type: STORE_SELECTED_SHOWROOM,
    showroom: {...showroom},
  }
}

export function toggleEventDatePicker() {
  return {
    type: TOGGLE_EVENT_DATE_PICKER,
  }
}

export function updateSelectedDate(date) {
  return {
    type: UPDATE_SELECTED_DATE,
    selectedDate: date,
  }
}
